'use strict';


module.exports = /*@ngInject*/ function($httpProvider) {

	$httpProvider.defaults.withCredentials = true;

};